import React, { memo } from 'react';
import { motion } from 'framer-motion';
const tomi = [{
  num: '1',
  title: 'Progettazione e Normativa (UDA)',
  desc: 'Programmazione annuale solida e professionale. Modelli di UDA trasversali pronti da compilare, gestione delle 33 ore di Educazione Civica e struttura completa per il Primo e Secondo Biennio. ✅ Apri, adatta e consegna al Dirigente con sicurezza.'
}, {
  num: '2',
  title: 'Morfosintassi e Potenziamento Lessicale',
  desc: "Dalla frase minima al periodo complesso. Percorsi pronti per le prove INVALSI, laboratori di scrittura e modulo speciale per la didattica dell'Italiano L2. ✅ Esercizi differenziati per livello, pronti per la fotocopia o lo schermo."
}, {
  num: '3',
  title: 'Le Origini: Dalle Corti al Rinascimento',
  desc: 'Dante, Petrarca, Boccaccio, Machiavelli. Percorsi innovativi che collegano il testo antico alla realtà dei tuoi studenti, con analisi del testo poetico, metrica e retorica già spiegate. ✅ 5 percorsi su Dante pronti per essere usati domani mattina.'
}, {
  num: '4',
  title: "L'Età dei Lumi e l'Ottocento",
  desc: 'Foscolo, Manzoni, Leopardi, Verga. Ogni autore con il suo percorso completo: contesto storico, analisi dei testi chiave, attività di comprensione e produzione. ✅ I Promessi Sposi in chiave moderna: finalmente coinvolge davvero i ragazzi.'
}, {
  num: '5',
  title: "Il Novecento e la Crisi dell'Io",
  desc: "Da Pascoli e D'Annunzio fino a Calvino, passando per Pirandello, Svevo, Montale, Ungaretti e Saba. Percorsi tematici, analisi comparative e attività per la produzione scritta. ✅ Percorsi pronti: l'identità, la guerra, la natura, la memoria."
}, {
  num: '6',
  title: 'Il Successo alla Maturità',
  desc: "Strategie per le Tipologie A, B e C della Prima Prova. Gestione del colloquio orale multidisciplinare. Tecniche di argomentazione e Public Speaking. Griglie ministeriali pronte all'uso. ✅ Griglie compatibili con i quadri di riferimento ministeriali 2025-2026."
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] relative border-t border-brand-orange/10" data-id="element-247">
      <div className="max-w-5xl mx-auto" data-id="element-248">
        <div className="text-center mb-8" data-id="element-249">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream mb-4" data-id="element-250">
            I 6 TOMI COMPLETI
          </motion.h2>
          <p className="text-xl text-brand-gold font-bold" data-id="element-251">
            Oltre 400 pagine di contenuto reale, pronto all'uso da oggi stesso.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-252">
          {tomi.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/10 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/40 transition-colors" data-id="element-253">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand-orange/10 transition-colors" data-id="element-254">
                {tomo.num}
              </div>
              <div className="relative z-10" data-id="element-255">
                <div className="inline-block bg-brand-orange text-white text-xs font-black px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-256">
                  Tomo {tomo.num}
                </div>
                <h3 className="text-xl font-bold text-brand-cream mb-3 leading-tight" data-id="element-257">
                  {tomo.title}
                </h3>
                <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-258">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}